import { utils } from "../../utils";


const iniState = {
    products: [],
    loading: true,
    size: utils.constants.cSizes[0],
    sort: utils.constants.order.None,
    // searchedProducts:'',
}

const reducer_product = (state = iniState, action) => {

    switch (action.type) {
        case utils.constants.PRODUCT_LIST_REQUEST: {
            return {
                ...state,
                loading: true,
                products: []
            }
        }
        case utils.constants.PRODUCT_LIST_SUCCESS: {
            return {
                ...state,
                loading: false,
                products: action.payload.products,
                filterProducts: action.payload.products
            }
        }
        case utils.constants.PRODUCT_LIST_FAIL: {
            return { ...state, loading: false, error: action.payload }
        }

        case utils.constants.FILTER_PRODUCT_BY_SIZE: {
            return {
                ...state,
                filterProducts: action.payload.filterProducts,
                size: action.payload.size
            }
        }
        case utils.constants.ORDER_PRODUCT_BY_PRICE: {
            return {
                products: action.payload.products,
                filterProducts: action.payload.filterProducts,
                sort: action.payload.sort
            }
        }
        case utils.constants.PRODUCT_BY_TXT_SEARCH: {
            return {
                products: action.payload.products,
                filterProducts: action.payload.searchedProducts,
            }
        }
        case utils.constants.COUNT_PRODUCT_INCREASE_OR_REMOVE: {
            return {
                products: action.payload.products,
                filterProducts: action.payload.sortedProducts,
            }
        }
        default:
            return { ...state };
    }
};


export default reducer_product;